import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import styles from './TableLayout.less'
import { useTable, useSortBy, usePagination, useTableState, useFilters } from 'react-table'
import matchSorter from 'match-sorter'

export class AdvanceTable extends React.Component {
  static propTypes = {
    columns: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    GetCurrentOpen: PropTypes.func
  };
  static defaultProps = {
  };
  constructor (props) {
    super(props)
    this.state = { }
  }
}

function fuzzyTextFilterFn (rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = val => !val

// Define a default UI for filtering
function DefaultColumnFilter ({
  column: { filterValue, preFilteredRows, setFilter }
}) {
  const count = preFilteredRows.length

  return (
    <input style={{ color: 'black' }}
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
      }}
      placeholder={`${count} filterable records...`}
    />
  )
}

function Table ({ columns, data, style, headerstyle }) {
  const defaultColumn = React.useMemo(
    () => ({
    // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }),
    []
  )

  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
            : true
        })
      }
    }),
    []
  )
  const tableState = useTableState({ pageIndex: 1 })
  const {
    getTableProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: [{ pageIndex, pageSize }]
  } = useTable(
    {
      columns,
      data,
      state: tableState,
      defaultColumn, // Be sure to pass the defaultColumn option
      filterTypes
    }, useFilters,
    useSortBy,
    usePagination
  )
  let i = 0
  // Render the UI for your table

  return (
    <div style={style} >
      <table {...getTableProps()}>
        <thead style={headerstyle}>
          {headerGroups.map(headerGroup => (
            <tr key={i++} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th key={i++} {...column.getHeaderProps()}>
                  {/* Render the columns filter UI */}
                  <div className={styles.filter}>{column.filter === 'fuzzyText' ? column.render('Filter') : null}</div>
                  <div>
                    <span {...column.getSortByToggleProps()}>
                      {column.render('Header')}
                      {/* Add a sort direction indicator */}
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </div>

                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {page.map(
            (row, i) =>
              prepareRow(row) || (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return (
                      <td key={i++} {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    )
                  })}
                </tr>
              )
          )}
        </tbody>
      </table>
      <div className={styles.pagination}>
        <button onClick={() => {} } >Goto First Open</button>{' '}
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
         Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
         | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[ 10, 20, 30, 40, 50, 100 ].map(pageSize => (
            <option key={pageSize} value={pageSize}>
             Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </div>

  )
}
function TablePlain ({ columns, data, style, mainstyle, headerstyle }) {
  return (
    <div className={styles.wrapper} style={mainstyle}>
      <Table columns={columns} data={data} headerstyle={headerstyle} style={style} />
    </div>
  )
}
export const TableLayout = (props) => { return <TablePlain name={props.name} {...props} component={AdvanceTable} /> } // eslint-disable-line
export default TableLayout
